import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroup5MasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroup5MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroup5MasterReferenceSlice = createSlice({
  name: 'stop/verificationGroup5MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationGroup5MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroup5MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroup5MasterReference } =
  verificationGroup5MasterReferenceSlice.actions;

export default verificationGroup5MasterReferenceSlice.reducer;
